module.exports = __webpack_public_path__ + "8c2ade503b34e31430d6c98aa29a52a3.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-900.woff
// module id = 676
// module chunks = 0